exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading[data-v-1b123c57]{background:#fff;padding:30px;margin-top:0;border-left:1px solid #d9dde4;border-right:1px solid #d9dde4;border-radius:0 0 3px 3px;color:#629c7c;border-bottom:1px solid;font-weight:100;font-size:36px;margin-bottom:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b123c57","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Header/index.vue
// module id = Z3D2
// module chunks = 0